import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterAccountingMappingStatusValueEnum } from "services/api/openapi"

export const TransactionMappingStatusFilter =
  SimpleAutocompleteFactory<TransactionFilterAccountingMappingStatusValueEnum>({
    completeMapping: "Complete Mapping",
    incompleteMapping: "Incomplete Mapping",
    noMapping: "No Mapping",
  })
